import { render, staticRenderFns } from "./Pendientes.vue?vue&type=template&id=668af006&"
import script from "./Pendientes.vue?vue&type=script&lang=js&"
export * from "./Pendientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports